import { render, staticRenderFns } from "./NewCatalogue.vue?vue&type=template&id=70860872&"
import script from "./NewCatalogue.vue?vue&type=script&lang=js&"
export * from "./NewCatalogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewCatalogue.vue"
export default component.exports